"use client";

import { Box } from "@mui/material";

export default function SpaceLC({ content }: {
    content: {
        settings: {
            height: string
        }
    };
}) {
    return <Box sx={{ height: parseInt(content.settings.height) ?? 48 }} />
}